// extracted by mini-css-extract-plugin
export default {"checkbox":"AudioCheckboxMedia_checkbox__niqgX","label":"AudioCheckboxMedia_label__bdg4D"};